import { useTranslations } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/TranslationContext";
import Header from "../messages/components/Header";
import Background from "@/components/Background";
import TabsErrorRetry from "./TabsErrorRetry";

export default function TabsError({
  reset,
  error,
  params,
}: {
  error: unknown;
  reset: () => void;
  params: { tenantId: string; messengerId: string; hostConfig: string; locale: string };
}) {
  const t = useTranslations();

  return (
    <Background params={params}>
      <Header messengerId={params.messengerId} />
      <TabsErrorRetry
        reset={reset}
        error={error}
        translatedRetryText={t("Error.retry")}
        translatedErrorText={t("Error.generic_error")}
      />
    </Background>
  );
}
